<nav class="admin-nav" *ngIf="isAdmin(user$ | async)" aria-label="Administration">
  <p class="admin-nav__eyebrow page__eyebrow">Administration</p>
  <ul class="admin-nav__list">
    <li *ngFor="let item of items">
      <a
        class="admin-nav__link"
        [routerLink]="item.link"
        [class.admin-nav__link--active]="isActive(item)"
      >
        <i class="pi {{ item.icon }}" aria-hidden="true"></i>
        <span>{{ item.label }}</span>
      </a>
    </li>
  </ul>
</nav>
